<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row>
                <Col span="24">
                    <Timeline>
                        <TimelineItem v-for="(item, index) in dataList" :key="index">
                            <p class="time">{{formatTime(item.create_time)}}</p>
                            <p class="content">{{item.remark}}</p>
                        </TimelineItem>
                    </Timeline>

                </Col>
            </Row>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">关闭</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedLogList} from "@/apis/dispersed";

export default {
    name: 'DispersedLog',
    components: {
    },
    data () {
        return {
            title: '零星项目日志',
            dataList: [],
            isBox: false
        }
    },
    methods: {
        /**
         功能：时间格式化
         time: 2026/09/12
         **/
        formatTime(time){
            if(!time) return '-';
            if(typeof time === 'string' && time.indexOf('-') >= 0) return time;
            const d = new Date(parseInt(time) * 1000);
            const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
            const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            const hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            const minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            return d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
        },
        /**
         功能：日志列表
         time: 2026/09/12
         **/
        getTreeList(small_project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedLogList(small_project_id).then(e => {
                that.dataList = e.data ?? [];
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(small_project_id, name){
            this.isBox = true;
            this.title = name + " - 零星项目日志"
            if(small_project_id) this.getTreeList(small_project_id);
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '零星项目日志';
            this.dataList =  [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
